
import Vue from 'vue'
import MenuReservationItem from '@/model/MenuReservationItem'
import { TranslateResult } from 'vue-i18n'
import moment from 'moment'
import { getLocale } from '@/services/system'
import { ReservationStatus } from '@/types/enums'
import BusinessTimeBlockCollection from "@/model/TimeBlockCollection";
import {GET_MODE} from "@/store/getter-types";
import InfoMenuGroupItemDialog from "@/components/order/InfoMenuGroupItemDialog.vue";
import RatingDialog from "@/components/dashboard/RatingDialog.vue";
import {usePiniaStore} from "@/store/piniaStore";
import {RatingModel} from "@/model/RatingModel";
import Moment from "moment/moment";
import {formatFloatPrice} from "@/services/formatter";
import {FETCH_DASHBOARD} from "@/store/action-types";

interface Data {
  showInfoDialog: boolean,
  key: boolean,
  showRatingDialog: boolean,

}

export default Vue.extend({
  name: 'GroupControlButtons',
  components: {
    RatingDialog
  },

  data (): Data {
    return {
      showInfoDialog: false,
      key:true,
      showRatingDialog:false,
    }
  },

  props: {
    date: { type: Date, required: true },
    reservationItem: { type: Object as () => MenuReservationItem | undefined },
    timeBlockCollection: { type: Array as () => BusinessTimeBlockCollection[] | null },
    saveInProgress: { type: Boolean, default: false },
    cancellationInProgress: { type: Boolean, default: false },
    isSelectionChanged: { type: Boolean, default: false },
    isSubmitButtonDisabled: { type: Boolean, default: false },
    isOfferEmpty: { type: Boolean, default: false },
    isAcceptanceProcess: { type: Boolean, default: false },
    isTimeBlockChanged: { type: Boolean, default: false },
    isAmountChanged: { type: Boolean, required: true },
    ratingDeliveryTimeData: { type: Number, required: false },
    lastReservationDetailData:{ type: Array as () => any[] },
    selectedOfferRating:{type: Object as () => any | undefined },
    lastReservationNumber:{ type: Array as () => any[] },
    isRefreshData: { type: Boolean, default: false },

  },

  computed: {
    isDateTwoDaysBeforeToday(): boolean {
      let isDataForRating: boolean = false
      let dateCreatedString: string = ''
      if (this.selectedOfferRating && this.selectedOfferRating.createdAt) {
        dateCreatedString = this.selectedOfferRating.createdAt
        isDataForRating = true
      } else if (this.date) {
        dateCreatedString = this.date
        isDataForRating = true
      } else {
        if (this.lastReservationDetailData && this.lastReservationDetailData.length > 0) {
          dateCreatedString = this.lastReservationDetailData[0].createdAt
          isDataForRating = true
        } else {
          dateCreatedString = this.date
          isDataForRating = false
        }

      }
      return isDataForRating
    },

    getPulse (): string {
        return "pulse-button"
    },

    getAcceptaceLabel (): string {
      if (this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'waitlisted' ) {
        return this.$t('orderPage.orderWaitList').toString()
      } else if(this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'rejected') {
        return this.$t('orderPage.orderRejected').toString()
      }else if(this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'accepted') {
        return this.$t('orderPage.orderAccepted').toString()
      } else {
        return ''
      }
      return ''
    },

    getLabel (): string {
      if (this.reservationItem && this.reservationItem.status === 'active') {
        return this.$t('orderPage.reservationIsActiveMessage').toString()
      } else if(this.reservationItem && this.reservationItem.status === 'canceled') {
        return this.$t('orderPage.reservationIsCanceledMessage').toString()
      }else if(this.reservationItem && this.reservationItem.status === 'delivered') {
        return this.$t('orderPage.reservationWasAlreadyDeliveredMessage').toString()
      } else {
        return ''
      }
      return ''
    },

    isReservationCanceled (): boolean {
      if(this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem!.acceptanceStatus.name) {
        return true
      } else {
        return false
      }
    },

    getConfig (): string {
      if (this.reservationItem && this.reservationItem.status === 'active') {
        return 'fas fa-check-circle'
      } else if(this.reservationItem && this.reservationItem.status === 'canceled') {
        return 'fas fa-minus-square'
      }else if(this.reservationItem && this.reservationItem.status === 'delivered') {
        return 'fas fa-cookie-bite-circle'
      } else {
        return ''
      }
      return ''
    },

    getIcon (): string {
      if (this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'waitlisted' ) {
        return 'fas fa-clock'
      } else if(this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'rejected') {
        return 'fas fa-times-circle'
      }else if(this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'accepted') {
        return 'fas fa-check-circle'
      } else {
        return ''
      }
      return ''
    },

    getColor (): string {
      if (this.reservationItem && this.reservationItem.status === 'active') {
        return 'green'
      } else if(this.reservationItem && this.reservationItem.status === 'canceled') {
        return 'red'
      }else if(this.reservationItem && this.reservationItem.status === 'delivered') {
        return '#8fa2c3'
      } else {
        return ''
      }
      return ''
    },

    isKioskMode (): boolean {
      return this.$store.getters[GET_MODE] === 'kiosk'
    },

    dateLabel (): string {
      return moment(this.date)
        .locale(getLocale())
        .format('dddd D.M YYYY').toLocaleLowerCase()
    },

    saveButtonIcon (): string {
      if (this.reservationItem && this.reservationItem.status === 'canceled') {
        return 'fas fa-undo'
      }

      return 'fas fa-save'
    },

    saveButtonLabel (): TranslateResult | undefined {
      if (!this.reservationItem) {
        return this.$t('orderPage.placeNewReservationButtonLabel')
      } else if (this.reservationItem && this.reservationItem.status === ReservationStatus.active) {
        return this.$t('orderPage.changeReservationButtonLabel')
      } else if (this.reservationItem && this.reservationItem.status === ReservationStatus.canceled) {
        return this.$t('orderPage.restoreReservationButtonLabel')
      }

      return undefined
    },

    saveButtonMinHeight (): number | undefined {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 80
      }

      return undefined
    },

    saveButtonMinWidth (): string | undefined {
      if (this.$vuetify.breakpoint.smAndDown) {
        return '100%'
      }

      return undefined
    },

    isSaveButtonDisabled (): boolean {

      if (this.cancellationInProgress) {
        return true
      }

      if (this.reservationItem && this.reservationItem.status === ReservationStatus.active) {
        return !(this.isSelectionChanged || this.isAmountChanged)
      }else if(!this.timeBlockCollection) {
        return true
      }else if(this.isOfferEmpty){
        return true
      }
      return false
    },

    isCancelButtonDisabled (): boolean {
      return this.saveInProgress
    },

    allowSave (): boolean {
      if (this.reservationItem && (['active', 'canceled'].includes(this.reservationItem.status))) {
        return true
      } else if (!this.reservationItem) {
        return true
      }

      return false
    },

    allowCancellation (): boolean {
      return this.reservationItem && this.reservationItem.status === ReservationStatus.active || false
    }
  },

  methods: {
    closeRatingDialog () {
      this.showRatingDialog = false
      this.$emit('update')
    },

    showRatingDialogClick () {
      this.showRatingDialog = true
    },
    // <editor-fold desc="Event handlers">
    onSaveButtonClick (): void {
      if (this.reservationItem && this.reservationItem.status === 'active') {
        this.$emit('changeReservationClick')
      } else if (this.reservationItem && this.reservationItem.status === 'canceled') {
        this.$emit('restoreReservationClick')
      } else {
        this.$emit('placeNewReservationClick')
      }
    },

    showInformationDialog(): void {
      this.showInfoDialog = true
    },

    onCancelButtonClick (): void {
      this.$emit('cancelReservationClick')
    },
    // </editor-fold>
  },
  mounted() {
  }
})
